/**
 * Target title section stores a string[]: index 0 = selected for resume output;
 * further entries are alternates kept in the editor for switching.
 */
export function getSelectedTargetTitle(titles: unknown): string | null {
  if (!Array.isArray(titles) || titles.length === 0) return null
  const selected = String(titles[0] ?? '').trim()
  return selected || null
}

export function getTargetTitleAlternates(titles: unknown): string[] {
  if (!Array.isArray(titles) || titles.length <= 1) return []
  const seen = new Set<string>()
  const out: string[] = []
  for (const raw of titles.slice(1)) {
    const t = String(raw ?? '').trim()
    if (!t || seen.has(t)) continue
    seen.add(t)
    out.push(t)
  }
  return out
}

/** All titles for editor list (selected first, then alternates). */
export function mergeTargetTitleOptions(titles: unknown): string[] {
  const selected = getSelectedTargetTitle(titles)
  const alternates = getTargetTitleAlternates(titles)
  if (!selected) return alternates
  return [selected, ...alternates.filter((t) => t !== selected)]
}
